import React, { Component } from "react";
import { withLocalize, Translate } from "react-localize-redux";
import translations from "../../translations/verify.json";
import profileTranslations from "../../translations/profile.json";
import ShareFacebook from "../../assets/storyIQ/facebook-share.png";
import ShareLinkedin from "../../assets/storyIQ/linkedin-share.png";
import {
	searchCredential,
	getPreviewWithDeliveryId,
} from "../../services/verifiedBackendService/search";
import RectLoader from "../../components/loaders/Rectangle";
import Rating from "@material-ui/lab/Rating";
import no_result from "../../assets/no-result/no-result-image.png";
import descCheck from "../../assets/storyIQ/check.svg";
import {
	MDBCarousel,
	MDBCarouselInner,
	MDBCarouselItem,
	MDBView,
	MDBContainer,
} from "mdbreact";
import {
	parseEvidences,
	parsePreviewEvidences,
} from "../../services/verifiedBackendService/certificate";
import ZoomCertificate from "../../components/verify/ZoomCertificate";
import { storeItem, getItem } from "../../backend/StorageUtils";
import "../../styles/storyIQ/web.scss";
import "../../styles/storyIQ/mobile.scss";
import { handleShareAnon } from "../../services/verifiedBackendService/event";
import { FacebookShareButton } from "react-share";
import LinkedinSharePopUp from "../../components/verify/LinkedinSharePopUpNew";
import { UserUtils } from "wallet-elementkit/dist/services";

const { innerWidth } = window;

class StoryIq extends Component {
	constructor(props) {
		super(props);
		this.state = {
			height: 0,
			certificateName: "",
			issued_by: null,
			url: "",
			badgeUrl: "",
			credno: window.location.pathname.split("/")[3],
			errorMessage: "",
			isMobile: props.isMobile,
			isLoading: true,
			courseRatingCount: 0,
			courseRating: 0.0,
			evidences: [],
			attendeeCount: 0,
			description: "",
			descriptionHtml: "",
			userFullName: "",
			activeImg: "badge",
			isScrollLocked: false,
			design: {},
			badgeDesign: {},
			isExpired: false,
			expireDatePlain: "",
			earningCriteria: "",
			certificateDetails: {},
			linkedinAuthCode: "",
			dialogOpen: false,
			linkedinAccessToken: "",
			linkedinUserId: "",
			organizationId: "",
			activeBlockWidth: 0,
		};
		this.props.addTranslation(translations);
		this.props.addTranslation(profileTranslations);
		this.getBlockWidth = this.getBlockWidth.bind(this);
	}

	getBlockWidth() {
		const block = document.getElementById("iq-cert");
		if (block) {
			this.setState({ activeBlockWidth: block.clientWidth });
		}
	}

	getMobileCredWidth() {
		if (this.props.isMobile && this.state.activeBlockWidth <= 768) {
			return this.state.activeBlockWidth;
		}
		return 546;
	}

	getLinkedinShareUrl = () => {
		const articleUrl = window.location.href.toString().split("?")[0];

		const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
			articleUrl
		)}`;

		return shareUrl;
	};

	handleClickOpen = () => {
		this.setState({ dialogOpen: true });
	};

	handleClose = () => {
		this.setState({ dialogOpen: false, linkedinAuthCode: null });
	};

	resetLinkedinAuthCode = () => {
		this.setState({
			linkedinAuthCode: null,
		});
	};

	componentWillReceiveProps(...args) {
		this.setState({
			isMobile: args[0].isMobile,
		});
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.linkedinAuthCode !== this.state.linkedinAuthCode &&
			this.state.linkedinAuthCode &&
			!this.state.dialogOpen
		) {
			this.handleClickOpen();
		}
	}

	componentDidMount() {
		const search = this.props.location.search;
		const linkedinAuthCode = new URLSearchParams(search).get("code");
		if (linkedinAuthCode) {
			this.setState({
				linkedinAuthCode,
			});
		}

		this.handleSearch();
		if (this.props.isMobile) {
			const height = document.getElementById("iq-cert").clientHeight;
			this.setState({ height });
		}
		this.setParsedEvidences();

		// Add block width tracking
		this.getBlockWidth();
		window.addEventListener("resize", this.getBlockWidth);
	}

	componentWillUnmount() {
		// Clean up resize listener
		window.removeEventListener("resize", this.getBlockWidth);
	}

	setParsedEvidences = () => {
		// Did not use await because of the unexpected setState behaviour. (discuss anil)
		if (this.props.isPreview) {
			parsePreviewEvidences(this.props.deliveryId).then((result) =>
				this.setState({
					evidences: result,
				})
			);
		} else {
			parseEvidences(this.state.credno).then((result) =>
				this.setState({
					evidences: result,
				})
			);
		}
	};
	handleSearch = async () => {
		let resp;
		let viewerId = getItem("__uid__");
		if (!viewerId) {
			viewerId = UserUtils.genereateViewerId();
			storeItem("__uid__", viewerId);
		}
		const queries = new URLSearchParams(this.props.location.search);
		const referrerUrl = document.referrer
			? document.referrer
			: queries.get("ref");
		if (this.props.isPreview) {
			const certNo = queries.get("certNo");
			const search = this.props.location.search;
			const lockScroll =
				new URLSearchParams(search).get("lockScroll") === "true";
			resp = await getPreviewWithDeliveryId(
				this.props.deliveryId,
				window.location.pathname.split("/")[1],
				window.location.href,
				certNo
			);
			this.setState({ isScrollLocked: lockScroll });
		} else {
			resp = await searchCredential(
				this.state.credno,
				window.location.pathname.split("/")[1],
				window.location.href,
				referrerUrl || window.location.href,
				viewerId
			);
		}

		if (!resp.success) {
			if (resp.isDeleted) {
				this.setState({
					errorMessage: "deleted",
					isLoading: false,
					issuerEmail: resp.organization.email,
				});
			} else {
				this.setState({ errorMessage: "notFound", isLoading: false });
			}
			return;
		}
		if (!resp.details.organization.logoLink) {
			resp.details.organization.logoLink =
				require("../../assets/fallbacks/organization.svg").default;
		}
		this.setState({
			certificateDetails: resp.details,
			certificateName: resp.result.name,
			organizationId: resp.details.organization.id,
			url: resp.result.url || "",
			badgeUrl: resp.result.badgeUrl || "",
			badgeDesign: resp.details.badgeDesign || null,
			design: resp.details.certificateDesign || null,
			issued_by: resp.result.issued_by,
			userFullName: resp.result.userFullName,
			courseRating: resp.details.detail.courseRating
				? resp.details.detail.courseRating
				: 0.0,
			courseRatingCount: resp.details.detail.courseRatingCount
				? this.numberWithCommas(resp.details.detail.courseRatingCount)
				: 0,
			attendeeCount: resp.details.detail.attendeeCount
				? this.numberWithCommas(resp.details.detail.attendeeCount)
				: 0,
			description: resp.details.detail.description,
			descriptionHtml: resp.details.detail.descriptionHtml,
			expireDatePlain: resp.details.detail.expireDate || "",
			earningCriteria:
				this.removeHtmlTags(resp.details.detail.earningCriteriaHTML) || "",
			isExpired: resp.details.isExpired,
			isLoading: false,
		});
	};

	numberWithCommas = (x) => {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};

	changeActiveImg = (active) => {
		this.setState({
			activeImg: active,
		});
	};

	handleCheckListDesc = (desc) => {
		if (!desc) return null;

		let document = new DOMParser().parseFromString(desc, "text/html");
		let pTags = document.getElementsByTagName("p");
		let res = [];

		// Removes unnecessary tags
		pTags = Array.from(pTags).filter((el) => el.innerText.trim());

		for (let i = 0; i < pTags.length / 2; i++) {
			res.push(
				<div className="st-desc-el" key={i}>
					<div className="st-desc-in">
						<img src={descCheck} alt="check" />
						<div
							dangerouslySetInnerHTML={{
								__html: pTags[2 * i].innerHTML.toString(),
							}}
						/>
					</div>
					{2 * i + 1 < pTags.length && (
						<div className="st-desc-in">
							<img src={descCheck} alt="check" />
							<div
								dangerouslySetInnerHTML={{
									__html: pTags[2 * i + 1].innerHTML.toString(),
								}}
							/>
						</div>
					)}
				</div>
			);
		}

		return res;
	};

	handleCheckListDescMobile = (desc) => {
		if (!desc) return null;

		let document = new DOMParser().parseFromString(desc, "text/html");
		let pTags = document.getElementsByTagName("p");
		let res = [];
		for (let i = 0; i < pTags.length / 2; i++) {
			let pt = pTags[i];
			res.push(
				<div className="st-desc-el" key={i}>
					<div className="st-desc-in">
						<img src={descCheck} alt="check" />
						<div
							dangerouslySetInnerHTML={{
								__html: pTags[2 * i].innerHTML.toString(),
							}}
						/>
					</div>
					{2 * i + 1 < pTags.length && (
						<div className="st-desc-in">
							<img src={descCheck} alt="check" />
							<div
								dangerouslySetInnerHTML={{
									__html: pTags[2 * i + 1].innerHTML.toString(),
								}}
							/>
						</div>
					)}
				</div>
			);
		}

		return res;
	};

	handleMailTo = async (type) => {
		if (this.props.activeLanguage) {
			if (type === "reportNotFound")
				if (this.props.activeLanguage.code === "en")
					window.open(
						`mailto:support@sertifier.com?subject=Certificate Not Found Issue with id ${this.state.credno}&body=Hello, %0D%0AI’m sharing with you my issue with the ${this.state.credno} serial numbered credential.%0D%0A%0D%0ARegards,`
					);
				else
					window.open(
						`mailto:support@sertifier.com?subject=Sertifika Bulunamadı Sorunu sertifika numarası: ${this.state.credno}&body=Merhaba, %0D%0A%0D%0A${this.state.credno} seri numaralı sertifikamla alakalı sorunumu sizinle aşağıda paylaşıyorum.%0D%0A%0D%0ASevgiler,`
					);
			if (type === "deletedCertificate")
				if (this.props.activeLanguage.code === "tr")
					window.open(
						`mailto:${this.state.issuerEmail}?subject=Silinmiş Sertifika, Sertifika numarası: ${this.state.credno}&body=Merhaba, %0D%0A%0D%0A${this.state.credno} seri numaralı sertifikamla alakalı sorunumu sizinle aşağıda paylaşıyorum.%0D%0A%0D%0ASevgiler,`
					);
				else
					window.open(
						`mailto:${this.state.issuerEmail}?subject=Deleted Certificate with id: ${this.state.credno}&body=Hello, %0D%0AI’m sharing with you my issue with the ${this.state.credno} serial numbered credential.%0D%0A%0D%0ARegards,`
					);
		}
	};

	removeHtmlTags(str) {
		if (str === null || str === "") return false;
		else str = str.toString();

		// Regular expression to identify HTML tags in
		// the input string. Replacing the identified
		// HTML tag with a null string.
		return str.replace(/(<([^>]+)>)/gi, "").trim();
	}

	handleDesc = (tag) => {
		const skillTags =
			(this.state.certificateDetails.skills &&
				this.state.certificateDetails.skills.reduce((tags, skill) => {
					return (tags += `#${skill.title
						.toLocaleLowerCase()
						.replace(/\s+/g, "")} `);
				}, "")) ||
			"";

		if (this.props.activeLanguage && this.props.activeLanguage.code === "tr")
			return `${this.state.issued_by} tarafından verilen ${this.state.certificateDetails.detail.title} başlıklı dijital sertifika/rozetime göz at!\n${skillTags}\n`;
		else
			return `Check out my ${this.state.certificateDetails.detail.title} digital certificate/badge issued by ${this.state.issued_by}!\n${skillTags}\n`;
	};

	handleClick = async (sharingFor) => {
		let res = await handleShareAnon(
			sharingFor,
			this.state.credno,
			this.state.organizationId
		);
		// let resJson = await res.json();
	};

	setLinkedinToken = (newToken) => {
		this.setState({
			linkedinAccessToken: newToken,
		});
	};

	setLinkedinUserId = (newId) => {
		this.setState({
			linkedinUserId: newId,
		});
	};

	render() {
		if (!this.props.isMobile) {
			return (
				<div
					id="storyIQ-web-main"
					style={
						this.props.isPreview && this.props.isScrollLocked
							? { overflow: "hidden", height: "100vh" }
							: {}
					}
				>
					<div>
						{!this.state.errorMessage ? (
							<div className="flex-column outer-main-storyIQ">
								{this.state.isExpired && (
									<div className="expired-banner">
										<span>
											<Translate id="expiredOn" />
											{this.state.expireDatePlain.split("T")[0]}
											<Translate id="noLongerValid" />
										</span>
									</div>
								)}
								<div
									className="flex-column inside"
									style={{
										marginTop: this.state.isExpired ? "0px" : "60px",
									}}
								>
									<div className="certificate-view-main">
										<div className="flex-column inside">
											<div className="flex-row certificate-overview">
												{this.state.isLoading ? (
													<div
														className="certificate-badge-container"
														style={{ minWidth: "500px", maxWidth: "500px" }}
													>
														<RectLoader
															viewBox="0 0 500 350"
															radius="0"
															width="500"
															height="440"
														/>
													</div>
												) : (
													<div className="flex-row" style={{ width: "100%" }}>
														<div className="certificate-badge-container">
															{this.state.design && !this.state.badgeDesign ? (
																<ZoomCertificate
																	height={480}
																	width={678}
																	design={this.state.design}
																	isBadge={false}
																/>
															) : (
																""
															)}
															{!this.state.design && this.state.badgeDesign ? (
																<ZoomCertificate
																	height={500}
																	width={500}
																	design={this.state.badgeDesign}
																	isBadge={true}
																/>
															) : (
																""
															)}
															{this.state.design && this.state.badgeDesign ? (
																<div className="flex-row certificate-badge">
																	<div className="flex-column img-select pointer-events-active">
																		<div
																			className="flex-column single-img"
																			style={{
																				backgroundColor:
																					this.state.activeImg === "badge"
																						? "#F0F0F0"
																						: "",
																			}}
																			onClick={() =>
																				this.changeActiveImg("badge")
																			}
																		>
																			<ZoomCertificate
																				height={90}
																				width={90}
																				design={this.state.badgeDesign}
																				isBadge={true}
																			/>
																		</div>
																		<div
																			className="flex-column single-img"
																			style={{
																				backgroundColor:
																					this.state.activeImg === "certificate"
																						? "#F0F0F0"
																						: "",
																			}}
																			onClick={() =>
																				this.changeActiveImg("certificate")
																			}
																		>
																			<ZoomCertificate
																				height={90}
																				width={90}
																				design={this.state.design}
																				isBadge={false}
																			/>
																		</div>
																	</div>
																	<div className="flex-row real-img-container">
																		{this.state.activeImg === "certificate" ? (
																			<ZoomCertificate
																				height={480}
																				width={678}
																				design={this.state.design}
																				isBadge={false}
																			/>
																		) : (
																			<ZoomCertificate
																				height={500}
																				width={500}
																				design={this.state.badgeDesign}
																				isBadge={true}
																			/>
																		)}
																	</div>
																</div>
															) : (
																""
															)}
															<div className="share-buttons">
																<span className="share-label">
																	<Translate id="shareThisCertificate" />
																</span>
																<div className="button-row">
																	<FacebookShareButton
																		onClick={() => this.handleClick("facebook")}
																		quote={this.handleDesc("facebook")}
																		url={
																			window.location.href
																				.toString()
																				.split("?")[0]
																		}
																		className="social-icon-container"
																		openShareDialogOnClick={true}
																	>
																		<div className="share-button facebook">
																			<img
																				className="share-icon"
																				alt="facebook"
																				src={ShareFacebook}
																			/>
																			<span className="facebook-label">
																				Facebook
																			</span>
																		</div>
																	</FacebookShareButton>
																	<a
																		href={this.getLinkedinShareUrl()}
																		target="_blank"
																		className="share-button linkedin"
																	>
																		<img
																			className="share-icon"
																			alt="linkedin"
																			src={ShareLinkedin}
																		/>
																		<span
																			style={{ color: "white" }}
																			className="linkedin-label"
																		>
																			LinkedIn
																		</span>
																	</a>
																</div>
															</div>
														</div>
														<div className="flex-column iq-details">
															<span className="course-cert">
																<Translate id="courseCert" />
															</span>
															<div className="flex-row title-button">
																<span className="title">
																	{this.state.certificateName}
																</span>
																{this.state.evidences.length > 0 ? (
																	<a
																		href={this.state.evidences[0].link}
																		target="_blank"
																	>
																		<div className="button">
																			<Translate id="enroll" />
																		</div>
																	</a>
																) : (
																	<a
																		href={this.state.earningCriteria}
																		target="_blank"
																	>
																		<div className="button">
																			<Translate id="enroll" />
																		</div>
																	</a>
																)}
															</div>
															<span className="issuer-text">
																<Translate id="storyIq" />
															</span>
															<div className="flex-row course-details">
																<Rating
																	name="half-rating-read"
																	defaultValue={this.state.courseRating}
																	precision={0.5}
																	size="small"
																	readOnly
																/>
																<p>
																	<span>
																		{this.state.courseRating.toString()}
																	</span>
																	<span>
																		{" "}
																		({this.state.courseRatingCount.toString()}{" "}
																		ratings)
																	</span>{" "}
																	| {this.state.attendeeCount.toString()}{" "}
																	Students Enrolled
																</p>
															</div>
															<div className="description-part flex-row">
																<span className="s4 description">
																	{this.state.isLoading ? (
																		<div
																			style={{ width: "660px", height: "90px" }}
																		>
																			<RectLoader
																				width="660"
																				height="90"
																				radius="4"
																			/>
																		</div>
																	) : this.state.descriptionHtml ? (
																		this.handleCheckListDesc(
																			this.state.descriptionHtml.replace(
																				/color:\s[^;]*;/g,
																				""
																			)
																		)
																	) : (
																		this.state.description
																	)}
																</span>
															</div>
														</div>
													</div>
												)}
											</div>
											<div className="iq-profile">
												<p>
													<span className="purp">
														{this.state.userFullName}'s
													</span>{" "}
													<Translate id="accVerified" />
													<br />
													<Translate id="storytellingBusiness" />
													{" " + this.state.certificateName + "."}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						) : (
							<div className="div-out">
								<div
									className="main-container"
									style={{
										flexDirection: "column",
										justifyContent: "flex-start",
										width: "fit-content",
										backgroundColor: "transparent",
									}}
								>
									<span style={{ fontSize: "36px", fontWeight: "780" }}>
										<Translate id="notFound1" />
									</span>
									<span style={{ fontSize: "24px", fontWeight: "0px" }}>
										<Translate id={`${this.state.errorMessage}2`} />
									</span>
									<span
										className="report-issue"
										onClick={() => {
											this.state.errorMessage === "deleted"
												? this.handleMailTo("deletedCertificate")
												: this.handleMailTo("reportNotFound");
										}}
									>
										<Translate
											id={
												this.state.errorMessage === "deleted"
													? "contactIssuer"
													: "reportIssue"
											}
										/>
									</span>
									<img
										alt="verified"
										src={no_result}
										style={{ height: "300px", paddingTop: "1%" }}
									/>
								</div>
							</div>
						)}
					</div>
					{!this.state.isLoading && this.state.dialogOpen && (
						<LinkedinSharePopUp
							dialogOpen={this.state.dialogOpen}
							handleClose={this.handleClose}
							disableAddToLinkedin={true}
							translate={this.props.translate}
							shareText={this.handleDesc("linkedin")}
							resetLinkedinAuthCode={this.resetLinkedinAuthCode}
							addLinkedin={() => {}}
							linkedinAuthCode={this.state.linkedinAuthCode}
							setLinkedinToken={this.setLinkedinToken}
							setLinkedinUserId={this.setLinkedinUserId}
							handleUncreatedImage={() => {}}
							issued_by={this.state.issued_by}
							certTitle={
								this.state.isLoading
									? this.state.certificateName
									: this.state.certificateDetails.detail.title
							}
							skills={this.state.certificateDetails.skills}
							articleUrl={window.location.href.toString().split("?")[0]}
							tokenCode={this.state.linkedinAccessToken}
							organization_id={this.state.organizationId}
							addTranslation={this.props.addTranslation}
							userId={this.state.linkedinUserId}
							credential_no={this.state.credno}
							redirectSuccessful={false}
							certificate_url={this.state.url}
							badge_url={this.state.badgeUrl}
						/>
					)}
				</div>
			);
		} else {
			return (
				<div
					id="story-mobile-main"
					style={
						this.props.isPreview
							? {
									marginTop: "0px",
							  }
							: {}
					}
				>
					<div>
						{!this.state.errorMessage ? (
							<div className="certificate-view-main-mobile-story">
								{this.state.isExpired && (
									<div className="flex-column expired-banner">
										<span>
											<Translate id="expiredOn" />
											{this.state.expireDatePlain.split("T")[0]}
											<Translate id="noLongerValid" />
										</span>
									</div>
								)}
								<div
									className="flex-column inside"
									style={{ marginTop: "20px" }}
								>
									<div style={{ marginTop: 0, width: "100%" }}>
										<div
											className="flex-column certificate-overview"
											id="iq-cert"
										>
											{this.state.isLoading ? (
												<div className="certificate-loader">
													<RectLoader
														width={innerWidth - 32}
														height={(innerWidth - 32) * 0.7075}
														radius="4"
													/>
												</div>
											) : (
												<div className="certificate-badge-container">
													{this.state.design && !this.state.badgeDesign ? (
														<div
															className="cert-container"
															style={{ width: 680, maxWidth: "100%" }}
														>
															<ZoomCertificate
																height={229}
																width={this.getMobileCredWidth()}
																design={this.state.design}
																isBadge={false}
															/>
														</div>
													) : (
														""
													)}
													{!this.state.design && this.state.badgeDesign ? (
														<div
															className="cert-container"
															style={{ width: 680 }}
														>
															<ZoomCertificate
																height={180}
																width={180}
																design={this.state.badgeDesign}
																isBadge={true}
															/>
														</div>
													) : (
														""
													)}
													{this.state.design && this.state.badgeDesign ? (
														<div className="carousel-my pointer-events-active">
															<MDBContainer>
																<MDBCarousel
																	activeItem={1}
																	length={2}
																	showControls={true}
																	showIndicators={false}
																	className="z-depth-1"
																	slide={false}
																	interval={9999999}
																>
																	<MDBCarouselInner>
																		<MDBCarouselItem itemId="1">
																			<MDBView>
																				<div className="flex-column carousel-img">
																					<ZoomCertificate
																						height={180}
																						width={180}
																						design={this.state.badgeDesign}
																						isBadge={true}
																					/>
																				</div>
																			</MDBView>
																		</MDBCarouselItem>
																		<MDBCarouselItem itemId="2">
																			<MDBView>
																				<div className="flex-column carousel-img">
																					<ZoomCertificate
																						height={229}
																						width={680}
																						design={this.state.design}
																						isBadge={false}
																					/>
																				</div>
																			</MDBView>
																		</MDBCarouselItem>
																	</MDBCarouselInner>
																</MDBCarousel>
															</MDBContainer>
														</div>
													) : (
														""
													)}
													<div className="share-buttons">
														<span className="share-label">
															<Translate id="shareThisCertificate" />
														</span>
														<div className="button-row">
															<FacebookShareButton
																onClick={() => this.handleClick("facebook")}
																quote={this.handleDesc("facebook")}
																url={
																	window.location.href.toString().split("?")[0]
																}
																className="social-icon-container"
																openShareDialogOnClick={true}
															>
																<div className="share-button facebook">
																	<img
																		className="share-icon"
																		alt="facebook"
																		src={ShareFacebook}
																	/>
																	<span className="facebook-label">
																		Facebook
																	</span>
																</div>
															</FacebookShareButton>
															<a
																href={this.getLinkedinShareUrl()}
																target="_blank"
																className="share-button linkedin"
															>
																<img
																	className="share-icon"
																	alt="linkedin"
																	src={ShareLinkedin}
																/>
																<span
																	style={{ color: "white" }}
																	className="linkedin-label"
																>
																	LinkedIn
																</span>
															</a>
														</div>
													</div>
												</div>
											)}
										</div>
										<div className="iq-profile">
											<p>
												<span className="purp">
													{this.state.userFullName}'s
												</span>{" "}
												<Translate id="accVerified" />
												<br />
												<Translate id="storytellingBusiness" />
												{" " + this.state.certificateName + "."}
											</p>
										</div>
										<div className="flex-column iq-details">
											<div className="flex-row course-details">
												{this.state.isLoading ? (
													<div
														style={{
															width: "100%",
															height: "160px",
															margin: "5px auto",
														}}
													>
														<RectLoader width="300" height="160" radius="4" />
													</div>
												) : (
													<div className="flex-row course-details">
														<Rating
															name="half-rating-read"
															defaultValue={
																this.state.isLoading
																	? 0
																	: this.state.courseRating
															}
															precision={0.5}
															readOnly
														/>
														<p>
															<span>{this.state.courseRating.toString()}</span>
															<span>
																{" "}
																({this.state.courseRatingCount.toString()}{" "}
																ratings)
															</span>{" "}
															| {this.state.attendeeCount.toString()} Students
															Enrolled
														</p>
													</div>
												)}
											</div>
											<div className="flex-row title-button">
												{this.state.evidences.length > 0 ? (
													<a
														style={{ width: "100%" }}
														href={this.state.evidences[0].link}
														target="_blank"
													>
														<div className="button">
															<Translate id="enroll" />
														</div>
													</a>
												) : (
													<a
														style={{ width: "100%" }}
														href={this.state.earningCriteria}
														target="_blank"
													>
														<div className="button">
															<Translate id="enroll" />
														</div>
													</a>
												)}
											</div>
											<span className="issuer-text">
												{" "}
												<Translate id="storyIq" />
											</span>

											<div className="description-part">
												<span
													className="description"
													style={{ marginTop: "10px" }}
												>
													{this.state.isLoading ? (
														<div style={{ width: "300px", height: "160px" }}>
															<RectLoader width="300" height="160" radius="4" />
														</div>
													) : this.state.descriptionHtml ? (
														this.handleCheckListDescMobile(
															this.state.descriptionHtml.replace(
																/color:\s[^;]*;/g,
																""
															)
														)
													) : (
														this.state.description
													)}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						) : (
							<div className="div-out">
								<div
									className="main-container"
									style={{
										flexDirection: "column",
										height: "450px",
										justifyContent: "flex-start",
										paddingTop: "5%",
										paddingLeft: "16px",
										paddingRight: "16px",
									}}
								>
									<span style={{ fontSize: "32px", fontWeight: "780" }}>
										<Translate id="notFound1" />
									</span>

									<span
										style={{
											textAlign: "center",
											fontSize: "24px",
											fontWeight: "0px",
										}}
									>
										<Translate id={`${this.state.errorMessage}2`} />
									</span>
									<span
										className="report-issue"
										onClick={() =>
											this.state.errorMessage === "deleted"
												? this.handleMailTo("deletedCertificate")
												: this.handleMailTo("reportNotFound")
										}
									>
										<Translate
											id={
												this.state.errorMessage === "deleted"
													? "contactIssuer"
													: "reportIssue"
											}
										/>
									</span>
									<img
										alt="verified"
										src={no_result}
										style={{ height: "246px", paddingTop: "3%" }}
									/>
								</div>
							</div>
						)}
					</div>
					{!this.state.isLoading && this.state.dialogOpen && (
						<LinkedinSharePopUp
							dialogOpen={this.state.dialogOpen}
							handleClose={this.handleClose}
							shareText={this.handleDesc("linkedin")}
							disableAddToLinkedin={true}
							translate={this.props.translate}
							resetLinkedinAuthCode={this.resetLinkedinAuthCode}
							addLinkedin={() => {}}
							linkedinAuthCode={this.state.linkedinAuthCode}
							setLinkedinToken={this.setLinkedinToken}
							setLinkedinUserId={this.setLinkedinUserId}
							handleUncreatedImage={() => {}}
							issued_by={this.state.issued_by}
							certTitle={
								this.state.isLoading
									? this.state.certificateName
									: this.state.certificateDetails.detail.title
							}
							skills={this.state.certificateDetails.skills}
							articleUrl={window.location.href.toString().split("?")[0]}
							tokenCode={this.state.linkedinAccessToken}
							organization_id={this.state.organizationId}
							addTranslation={this.props.addTranslation}
							userId={this.state.linkedinUserId}
							credential_no={this.state.credno}
							redirectSuccessful={false}
							certificate_url={this.state.url}
							badge_url={this.state.badgeUrl}
						/>
					)}
				</div>
			);
		}
	}
}

export default withLocalize(StoryIq);
